// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ASEg","option":"styles_option__3NHoN","active":"styles_active__2be3A"};